gz-info-box {
  padding-left: 0;
}

#link-to-step2 {
  text-decoration: underline;
}

#description.disabled {
  color: var(--grey-layout-200-disabled);
}
